import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "平台客服" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.config,
          "label-col": { span: 2 },
          "wrapper-col": { span:8 },
          autocomplete: "off",
          onFinish: _ctx.onFinish
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "微信号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.wechat,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.wechat) = $event)),
                  placeholder: "请输入微信号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.phone,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.phone) = $event)),
                  placeholder: "请输入手机号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "上班时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.business_time,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.business_time) = $event)),
                  placeholder: "请输入上班时间"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 2, span: 8 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onFinish"])
      ]),
      _: 1
    })
  ]))
}